import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM15.07 8L12.24 10.83L9.41 8L8 9.41L10.83 12.24L8 15.07L9.41 16.48L12.24 13.65L15.07 16.48L16.48 15.07L13.65 12.24L16.48 9.41L15.07 8Z" />
    </CommonSVGIcon>
  );
}

/*
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM15.07 8L12.24 10.83L9.41 8L8 9.41L10.83 12.24L8 15.07L9.41 16.48L12.24 13.65L15.07 16.48L16.48 15.07L13.65 12.24L16.48 9.41L15.07 8Z" fill="#DE350B"/>
</svg>

*/